import { ReactComponent as Add } from "@svgr/webpack?-svgo,+titleProp,+ref!./Add.svg";
import { ReactComponent as All } from "@svgr/webpack?-svgo,+titleProp,+ref!./All.svg";
import { ReactComponent as Adwords } from "@svgr/webpack?-svgo,+titleProp,+ref!./Adwords.svg";
import { ReactComponent as Audience } from "@svgr/webpack?-svgo,+titleProp,+ref!./Audience.svg";
import { ReactComponent as Bandsintown } from "@svgr/webpack?-svgo,+titleProp,+ref!./Bandsintown.svg";
import { ReactComponent as Book } from "@svgr/webpack?-svgo,+titleProp,+ref!./Book.svg";
import { ReactComponent as Brand } from "@svgr/webpack?-svgo,+titleProp,+ref!./Brand.svg";
import { ReactComponent as Brightness } from "@svgr/webpack?-svgo,+titleProp,+ref!./Brightness.svg";
import { ReactComponent as Calendar } from "@svgr/webpack?-svgo,+titleProp,+ref!./Calendar.svg";
import { ReactComponent as Camera } from "@svgr/webpack?-svgo,+titleProp,+ref!./Camera.svg";
import { ReactComponent as Checklist } from "@svgr/webpack?-svgo,+titleProp,+ref!./Checklist.svg";
import { ReactComponent as Chrome } from "@svgr/webpack?-svgo,+titleProp,+ref!./Chrome.svg";
import { ReactComponent as City } from "@svgr/webpack?-svgo,+titleProp,+ref!./City.svg";
import { ReactComponent as Clipboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Clipboard.svg";
import { ReactComponent as Clock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Clock.svg";
import { ReactComponent as Close } from "@svgr/webpack?-svgo,+titleProp,+ref!./Close.svg";
import { ReactComponent as Connected } from "@svgr/webpack?-svgo,+titleProp,+ref!./Connected.svg";
import { ReactComponent as CreditCard } from "@svgr/webpack?-svgo,+titleProp,+ref!./CreditCard.svg";
import { ReactComponent as CurrentLocation } from "@svgr/webpack?-svgo,+titleProp,+ref!./CurrentLocation.svg";
import { ReactComponent as Delete } from "@svgr/webpack?-svgo,+titleProp,+ref!./Delete.svg";
import { ReactComponent as Description } from "@svgr/webpack?-svgo,+titleProp,+ref!./Description.svg";
import { ReactComponent as Desktop } from "@svgr/webpack?-svgo,+titleProp,+ref!./Desktop.svg";
import { ReactComponent as Disconnected } from "@svgr/webpack?-svgo,+titleProp,+ref!./Disconnected.svg";
import { ReactComponent as Download } from "@svgr/webpack?-svgo,+titleProp,+ref!./Download.svg";
import { ReactComponent as Duplicate } from "@svgr/webpack?-svgo,+titleProp,+ref!./Duplicate.svg";
import { ReactComponent as Edit } from "@svgr/webpack?-svgo,+titleProp,+ref!./Edit.svg";
import { ReactComponent as Email } from "@svgr/webpack?-svgo,+titleProp,+ref!./Email.svg";
import { ReactComponent as Envelope } from "@svgr/webpack?-svgo,+titleProp,+ref!./Envelope.svg";
import { ReactComponent as Error } from "@svgr/webpack?-svgo,+titleProp,+ref!./Error.svg";
import { ReactComponent as Export } from "@svgr/webpack?-svgo,+titleProp,+ref!./Export.svg";
import { ReactComponent as FacebookComment } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookComment.svg";
import { ReactComponent as FacebookLike } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookLike.svg";
import { ReactComponent as FacebookMessenger } from "@svgr/webpack?-svgo,+titleProp,+ref!./FacebookMessenger.svg";
import { ReactComponent as Facebook } from "@svgr/webpack?-svgo,+titleProp,+ref!./Facebook.svg";
import { ReactComponent as Failure } from "@svgr/webpack?-svgo,+titleProp,+ref!./Failure.svg";
import { ReactComponent as File } from "@svgr/webpack?-svgo,+titleProp,+ref!./File.svg";
import { ReactComponent as Filter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Filter.svg";
import { ReactComponent as Form } from "@svgr/webpack?-svgo,+titleProp,+ref!./Form.svg";
import { ReactComponent as Gallery } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gallery.svg";
import { ReactComponent as Game } from "@svgr/webpack?-svgo,+titleProp,+ref!./Game.svg";
import { ReactComponent as Gear } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gear.svg";
import { ReactComponent as Google } from "@svgr/webpack?-svgo,+titleProp,+ref!./Google.svg";
import { ReactComponent as Hashtag } from "@svgr/webpack?-svgo,+titleProp,+ref!./Hashtag.svg";
import { ReactComponent as Hourglass } from "@svgr/webpack?-svgo,+titleProp,+ref!./Hourglass.svg";
import { ReactComponent as InstagramComment } from "@svgr/webpack?-svgo,+titleProp,+ref!./InstagramComment.svg";
import { ReactComponent as InstagramLike } from "@svgr/webpack?-svgo,+titleProp,+ref!./InstagramLike.svg";
import { ReactComponent as Instagram } from "@svgr/webpack?-svgo,+titleProp,+ref!./Instagram.svg";
import { ReactComponent as Key } from "@svgr/webpack?-svgo,+titleProp,+ref!./Key.svg";
import { ReactComponent as Legacy } from "@svgr/webpack?-svgo,+titleProp,+ref!./Legacy.svg";
import { ReactComponent as Link } from "@svgr/webpack?-svgo,+titleProp,+ref!./Link.svg";
import { ReactComponent as Lock } from "@svgr/webpack?-svgo,+titleProp,+ref!./Lock.svg";
import { ReactComponent as Logo } from "@svgr/webpack?-svgo,+titleProp,+ref!./Logo.svg";
import { ReactComponent as Marker } from "@svgr/webpack?-svgo,+titleProp,+ref!./Marker.svg";
import { ReactComponent as MAX } from "@svgr/webpack?-svgo,+titleProp,+ref!./MAX.svg";
import { ReactComponent as Message } from "@svgr/webpack?-svgo,+titleProp,+ref!./Message.svg";
import { ReactComponent as Music } from "@svgr/webpack?-svgo,+titleProp,+ref!./Music.svg";
import { ReactComponent as NoImage } from "@svgr/webpack?-svgo,+titleProp,+ref!./NoImage.svg";
import { ReactComponent as Palette } from "@svgr/webpack?-svgo,+titleProp,+ref!./Palette.svg";
import { ReactComponent as Pencil } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pencil.svg";
import { ReactComponent as Percentage } from "@svgr/webpack?-svgo,+titleProp,+ref!./Percentage.svg";
import { ReactComponent as Phone } from "@svgr/webpack?-svgo,+titleProp,+ref!./Phone.svg";
import { ReactComponent as Picture } from "@svgr/webpack?-svgo,+titleProp,+ref!./Picture.svg";
import { ReactComponent as Pinterest } from "@svgr/webpack?-svgo,+titleProp,+ref!./Pinterest.svg";
import { ReactComponent as Preferences } from "@svgr/webpack?-svgo,+titleProp,+ref!./Preferences.svg";
import { ReactComponent as Record } from "@svgr/webpack?-svgo,+titleProp,+ref!./Record.svg";
import { ReactComponent as Refresh } from "@svgr/webpack?-svgo,+titleProp,+ref!./Refresh.svg";
import { ReactComponent as RemoveCircle } from "@svgr/webpack?-svgo,+titleProp,+ref!./RemoveCircle.svg";
import { ReactComponent as Remove } from "@svgr/webpack?-svgo,+titleProp,+ref!./RemoveDefault.svg";
import { ReactComponent as Report } from "@svgr/webpack?-svgo,+titleProp,+ref!./Report.svg";
import { ReactComponent as Ribbon } from "@svgr/webpack?-svgo,+titleProp,+ref!./Ribbon.svg";
import { ReactComponent as Search } from "@svgr/webpack?-svgo,+titleProp,+ref!./Search.svg";
import { ReactComponent as Send } from "@svgr/webpack?-svgo,+titleProp,+ref!./Send.svg";
import { ReactComponent as Series } from "@svgr/webpack?-svgo,+titleProp,+ref!./Series.svg";
import { ReactComponent as SetTheSet } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetTheSet.svg";
import { ReactComponent as Share } from "@svgr/webpack?-svgo,+titleProp,+ref!./Share.svg";
import { ReactComponent as Shuffle } from "@svgr/webpack?-svgo,+titleProp,+ref!./Shuffle.svg";
import { ReactComponent as Snapchat } from "@svgr/webpack?-svgo,+titleProp,+ref!./Snapchat.svg";
import { ReactComponent as Sort } from "@svgr/webpack?-svgo,+titleProp,+ref!./Sort.svg";
import { ReactComponent as SoundCloud } from "@svgr/webpack?-svgo,+titleProp,+ref!./SoundCloud.svg";
import { ReactComponent as Spotify } from "@svgr/webpack?-svgo,+titleProp,+ref!./Spotify.svg";
import { ReactComponent as SpreadSheet } from "@svgr/webpack?-svgo,+titleProp,+ref!./SpreadSheet.svg";
import { ReactComponent as Stage1 } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stage1.svg";
import { ReactComponent as Stage2 } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stage2.svg";
import { ReactComponent as Stage3 } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stage3.svg";
import { ReactComponent as Stage4 } from "@svgr/webpack?-svgo,+titleProp,+ref!./Stage4.svg";
import { ReactComponent as Style } from "@svgr/webpack?-svgo,+titleProp,+ref!./Style.svg";
import { ReactComponent as Success } from "@svgr/webpack?-svgo,+titleProp,+ref!./Success.svg";
import { ReactComponent as Tablet } from "@svgr/webpack?-svgo,+titleProp,+ref!./Tablet.svg";
import { ReactComponent as TerrestrialRadio } from "@svgr/webpack?-svgo,+titleProp,+ref!./TerrestrialRadio.svg";
import { ReactComponent as Ticket } from "@svgr/webpack?-svgo,+titleProp,+ref!./Ticket.svg";
import { ReactComponent as Ticket2 } from "@svgr/webpack?-svgo,+titleProp,+ref!./Ticket2.svg";
import { ReactComponent as Twitter } from "@svgr/webpack?-svgo,+titleProp,+ref!./Twitter.svg";
import { ReactComponent as Unlink } from "@svgr/webpack?-svgo,+titleProp,+ref!./Unlink.svg";
import { ReactComponent as Update } from "@svgr/webpack?-svgo,+titleProp,+ref!./Update.svg";
import { ReactComponent as Upload } from "@svgr/webpack?-svgo,+titleProp,+ref!./Upload.svg";
import { ReactComponent as USD } from "@svgr/webpack?-svgo,+titleProp,+ref!./USD.svg";
import { ReactComponent as Video } from "@svgr/webpack?-svgo,+titleProp,+ref!./Video.svg";
import { ReactComponent as Website } from "@svgr/webpack?-svgo,+titleProp,+ref!./Website.svg";
import { ReactComponent as Widescreen } from "@svgr/webpack?-svgo,+titleProp,+ref!./Widescreen.svg";
import { ReactComponent as YouTube } from "@svgr/webpack?-svgo,+titleProp,+ref!./YouTube.svg";
import { ReactComponent as CalendarAdd } from "@svgr/webpack?-svgo,+titleProp,+ref!./CalendarAdd.svg";
import { ReactComponent as Infinity } from "@svgr/webpack?-svgo,+titleProp,+ref!./Infinity.svg";
import { ReactComponent as SetList } from "@svgr/webpack?-svgo,+titleProp,+ref!./SetList.svg";
import { ReactComponent as Trophy } from "@svgr/webpack?-svgo,+titleProp,+ref!./Trophy.svg";
import { ReactComponent as Dashboard } from "@svgr/webpack?-svgo,+titleProp,+ref!./Dashboard.svg";
import { ReactComponent as Archive } from "@svgr/webpack?-svgo,+titleProp,+ref!./Archive.svg";
import { ReactComponent as QuestionHighlight } from "@svgr/webpack?-svgo,+titleProp,+ref!./QuestionHighlight.svg";
import { ReactComponent as EndCall } from "@svgr/webpack?-svgo,+titleProp,+ref!./EndCall.svg";
import { ReactComponent as InstantMessage } from "@svgr/webpack?-svgo,+titleProp,+ref!./InstantMessage.svg";
import { ReactComponent as NextCall } from "@svgr/webpack?-svgo,+titleProp,+ref!./NextCall.svg";
import { ReactComponent as VideoChat } from "@svgr/webpack?-svgo,+titleProp,+ref!./VideoChat.svg";
import { ReactComponent as VideoOff } from "@svgr/webpack?-svgo,+titleProp,+ref!./VideoOff.svg";
import { ReactComponent as Gift } from "@svgr/webpack?-svgo,+titleProp,+ref!./Gift.svg";
import { ReactComponent as Charity } from "@svgr/webpack?-svgo,+titleProp,+ref!./Charity.svg";
import { ReactComponent as Shopping } from "@svgr/webpack?-svgo,+titleProp,+ref!./Shopping.svg";
export const FormIcons = {
  Add,
  Adwords,
  All,
  Audience,
  Bandsintown,
  Book,
  Brand,
  Brightness,
  Calendar,
  Camera,
  Checklist,
  Chrome,
  City,
  Clipboard,
  Clock,
  Close,
  Connected,
  CreditCard,
  CurrentLocation,
  Delete,
  Description,
  Desktop,
  Disconnected,
  Download,
  Duplicate,
  Edit,
  Email,
  Envelope,
  Error,
  Export,
  FacebookComment,
  FacebookLike,
  FacebookMessenger,
  Facebook,
  Failure,
  File,
  Filter,
  Form,
  Gallery,
  Game,
  Gear,
  Google,
  Hashtag,
  Hourglass,
  InstagramComment,
  InstagramLike,
  Instagram,
  Key,
  Legacy,
  Link,
  Lock,
  Logo,
  Marker,
  MAX,
  Message,
  Music,
  NoImage,
  Palette,
  Pencil,
  Percentage,
  Phone,
  Picture,
  Pinterest,
  Preferences,
  Record,
  Refresh,
  RemoveCircle,
  Remove,
  Report,
  Ribbon,
  Search,
  Send,
  Series,
  SetTheSet,
  Share,
  Shuffle,
  Snapchat,
  Sort,
  SoundCloud,
  Spotify,
  SpreadSheet,
  Stage1,
  Stage2,
  Stage3,
  Stage4,
  Style,
  Success,
  Tablet,
  TerrestrialRadio,
  Ticket,
  Ticket2,
  Twitter,
  Unlink,
  Update,
  Upload,
  USD,
  Video,
  Website,
  Widescreen,
  YouTube,
  CalendarAdd,
  Infinity,
  SetList,
  Trophy,
  Dashboard,
  Archive,
  QuestionHighlight,
  EndCall,
  InstantMessage,
  NextCall,
  VideoChat,
  VideoOff,
  Gift,
  Charity,
  Shopping
};
export const FormIconNames = ["Add", "Adwords", "All", "Audience", "Bandsintown", "Book", "Brand", "Brightness", "Calendar", "Camera", "Checklist", "Chrome", "City", "Clipboard", "Clock", "Close", "Connected", "CreditCard", "CurrentLocation", "Delete", "Description", "Desktop", "Disconnected", "Download", "Duplicate", "Edit", "Email", "Envelope", "Error", "Export", "FacebookComment", "FacebookLike", "FacebookMessenger", "Facebook", "Failure", "File", "Filter", "Form", "Gallery", "Game", "Gear", "Google", "Hashtag", "Hourglass", "InstagramComment", "InstagramLike", "Instagram", "Key", "Legacy", "Link", "Lock", "Logo", "Marker", "MAX", "Message", "Music", "NoImage", "Palette", "Pencil", "Percentage", "Phone", "Picture", "Pinterest", "Preferences", "Record", "Refresh", "RemoveCircle", "Remove", "Report", "Ribbon", "Search", "Send", "Series", "SetTheSet", "Share", "Shuffle", "Snapchat", "Sort", "SoundCloud", "Spotify", "SpreadSheet", "Stage1", "Stage2", "Stage3", "Stage4", "Style", "Success", "Tablet", "TerrestrialRadio", "Ticket", "Ticket2", "Twitter", "Unlink", "Update", "Upload", "USD", "Video", "Website", "Widescreen", "YouTube", "CalendarAdd", "Infinity", "SetList", "Trophy", "Dashboard", "Archive", "QuestionHighlight", "EndCall", "InstantMessage", "NextCall", "VideoChat", "VideoOff", "Gift", "Charity", "Shopping"];